<template>
  <div id="Permissions">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-form lazy-validation ref="searchValidation">
              <v-text-field
                style="max-width: 250px"
                dense
                outlined
                hide-details
                clearable
                :placeholder="$t('general.search')"
                v-model="search"
                append-icon="search"
                class="mr-2"
                :rules="rules.textNoSpecialChars"
                @click:append="searching"
                @keyup.enter="searching"
              />
            </v-form>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute opacity="0" :value="loadTable"/>
            <v-data-table
               :search="search"
              :headers="headers"
              :items="users"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get"
            >
              <template v-slot:item="props" >
                <tr>
                  <td align="left">{{props.item.name}}</td>
                  <td align="left">{{props.item.last_name}}</td>
                  <td align="left">{{props.item.email}}</td>
                  <td align="left">{{props.item.license_number}}</td>
                  <td align="left">{{props.item.phone}}</td>
                  <td align="left">{{props.item.roles ? props.item.roles[0].name : ''}}</td>
                  <td align="left">
                    <v-icon class="mr-4" small @click="edit(props.item)">far fa-edit</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog scrollable persistent v-model="permissionsDialog" width="900px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="primary--text">{{$t('permissions.edit')}}</h3>
        </v-toolbar>
        <v-card-text class="text-center" v-if="loadItem">
          <v-progress-circular size="50" color="primary" indeterminate/>
        </v-card-text>
        <v-card-text v-if="!loadItem">
          <v-row>
            <v-col cols="6">
              <h3>
                <span class="primary--text">{{$t('general.user')}}: </span> {{editedItem.name + ' ' + (editedItem.last_name ? editedItem.last_name : '')}}
              </h3>
            </v-col>
            <v-col cols="6">
              <h3>
                <span class="primary--text">{{$t('general.role')}}: </span> {{editedItem.roles ? editedItem.roles[0].name : ''}}
              </h3>
            </v-col>
            <v-col class="py-0" cols="12">
              <v-divider/>
            </v-col>
            <v-col cols="4">
              <v-card outlined>
                <v-card-title>
                  <span>{{$t('permissions.rolePermissions')}}</span>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <v-list dense disabled>
                    <v-list-item-group>
                      <v-list-item @click="removeP(index)" v-for="(item, index) in editedItem.roles[0].permissions" :key="item.id">
                        <v-list-item-content>
                          <v-list-item-title><v-icon>radio_button_checked</v-icon> &nbsp;&nbsp; {{$t(`permissions.${item.name}`)}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="8">
              <v-card outlined>
                <v-card-title>
                  <span>{{$t('permissions.availablePermissions')}}</span>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="6" v-for="item in filtPermi" :key="item.id">
                      <v-checkbox hide-details :label="$t(`permissions.${item.name}`)" :value="item" v-model="editedItem.permissions"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" outlined @click="close">{{$t('general.cancel')}}</v-btn>
          <v-btn :loading="loading" :disabled="loading" color="primary" depressed @click="save">{{$t('general.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('general.confirm')}}</h3>
        </v-toolbar>
        <v-card-text>
          {{$t('general.deleteMessage')}}
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="error" text @click="close">{{$t('general.cancel')}}</v-btn>
          <v-btn color="error" depressed>{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Permissions',
  data () {
    return {
      loading: false,
      dialog: false,
      loadTable: false,
      loadItem: true,
      permissionsDialog: false,
      filtPermi: [],
      search: '',
      pageCount: 0,
      permissions: [],
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      editedItem: {
        name: '',
        roles: {
          permissions: [],
          name: ''
        },
        permissions: []
      },
      defaultItem: {
        name: '',
        roles: {
          permissions: [],
          name: ''
        },
        permissions: []
      },
      removedItem: {},
      users: [],
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('general.name'),
          value: 'name',
          align: 'left'
        },
        {
          text: this.$t('general.lastNames'),
          value: 'last_name',
          align: 'left'
        },
        {
          text: this.$t('general.email'),
          value: 'email',
          align: 'left'
        },
        {
          text: this.$t('general.licence'),
          value: 'license_number',
          align: 'left'
        },
        {
          text: this.$t('general.phone'),
          value: 'phone',
          align: 'left'
        },
        {
          text: this.$t('general.role'),
          value: 'roles',
          align: 'left'
        },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    search (val) {
      if (val === '' || val === null) this.searching()
    }
  },
  created () {
    this.get()
    this.$store.dispatch('permissions/get', {event: {context: this}})
  },
  methods: {
    filterPermissions () {
      let filter = this.permissions
      if (this.editedItem.roles[0].permissions.length > 0) {
        this.editedItem.roles[0].permissions.forEach(item => {
          filter = filter.filter(permiso => permiso.id !== item.id)
        })
        this.filtPermi = filter
      } else {
        this.filtPermi = filter
      }
    },
    save () {
      this.loading = true
      this.$store.dispatch('permissions/post', {event: {item: this.editedItem, context: this}})
    },
    edit (item) {
      this.$store.dispatch('permissions/getUserById', {event: {id: item.id, context: this}})
      this.permissionsDialog = true
    },
    searching() {
      if(this.search && !this.$refs.searchValidation.validate()) return this.showNotification(this.$t('validation.noSpecialChars'), 'warn', -1)
    
      this.$refs.searchValidation.resetValidation()

      this.options.page = 1
      this.get()
    },
    close () {
      this.dialog = false
      this.loading = false
      this.permissionsDialog = false
      this.loadItem = true,
      this.editedItem = Object.assign({}, this.defaultItem)
      this.removedItem = {}
      this.selectedPermissions = []
    },
    remove(item) {
      this.removedItem = item
      this.dialog = true
    },
    get () {
      this.loadTable = true
      this.$store.dispatch('permissions/getUsers', {
        event: {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
          ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
          find: this.search,
          context: this
        }
      })
    }
  }
}
</script>